import axios from "axios";
import { useEffect, useState } from "react";
import { FaUser, FaLock, FaHistory } from "react-icons/fa";
import { formatToZMW, rootUrl, sumOfArray } from "../../helpers";
import { useAuth } from "../../context/auth-context";
import Receipt from "./receipt";
import Modal from "../../components/Modal";

export default function ProfilePage({allData, groupedData}) {
  const [password, setPassword] = useState("password123");
  const [isEditing, setIsEditing] = useState(false);
  const [activeTab, setActiveTab] = useState("details");
  const [showBillModal, setShowBillModal] = useState(false);
  const [recId, setRecId] = useState(null);
    
    const auth = useAuth();

      
    // useEffect(() => {
    //     fetchData()
    // }, [])  


  return (
    <div className="max-w-lg mx-auto mt-10 p-5">
      {/* Profile Card */}
      <div className="bg-white p-6">
        <div className="flex items-center gap-4 mb-5">
          <FaUser className="text-3xl" />
          <h1 className="text-2xl font-bold">Profile</h1>
        </div>
            
        {/* Tabs */}
        <div className="flex border-b">
          <button
            className={`py-2 px-4 w-1/2 text-center ${activeTab === "details" ? "border-b-2 border-blue-500 text-blue-500 font-semibold" : "text-gray-600"}`}
            onClick={() => setActiveTab("details")}
          >
            <FaUser className="inline mr-2" /> Basic Details
          </button>
          <button
            className={`py-2 px-4 w-1/2 text-center ${activeTab === "transactions" ? "border-b-2 border-blue-500 text-blue-500 font-semibold" : "text-gray-600"}`}
            onClick={() => setActiveTab("transactions")}
          >
            <FaHistory className="inline mr-2" /> Transactions
          </button>
        </div>

        {/* Basic Details */}
        {activeTab === "details" && (
          <div className="mt-4 space-y-4">
            <div>
              <label className="text-sm font-medium">Full Name: </label>
              <br/>
              {/* <input
                type="text"
                value="John Doe"
                disabled
                className="w-full p-2 mt-1 border rounded bg-gray-100"
              /> */}
              {allData.users.find(a=>a.id == auth.user?.id)?.firstname} {allData.users.find(a=>a.id == auth.user?.id)?.lastname}
            </div>
            <div>
              <label className="text-sm font-medium">Email</label>
              <br/>
              {/* <input
                type="email"
                value="johndoe@example.com"
                disabled
                className="w-full p-2 mt-1 border rounded bg-gray-100"
              /> */}

            {allData.users.find(a=>a.id == auth.user?.id)?.email}
            </div>
            <div>
              <label className="text-sm font-medium flex items-center gap-2">
                <FaLock /> Password
              </label>
              <div className="flex gap-2 mt-1">
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={!isEditing}
                  className={`w-full p-2 border rounded ${isEditing ? "border-blue-500 bg-white" : "bg-gray-100"}`}
                />
                <button
                  className="px-3 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
                  onClick={() => setIsEditing(!isEditing)}
                >
                  {isEditing ? "Save" : "Edit"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Transactions */}
        {activeTab === "transactions" && (
          <div className="mt-4 space-y-2">
            <h2 className="text-lg font-semibold mb-2">Transaction History</h2>

            {
                groupedData.sort((a, b) => new Date(b.date) - new Date(a.date)).map((receipt) => (
                    <div onClick={()=>setRecId(receipt.voucher)} key={receipt.voucher} className="bg-gray-100 p-3 rounded-md flex justify-between cursor-pointer">
               
                        <span>{receipt.voucher}</span>
                        <span>{receipt.paye}</span>
                        <span className={receipt.type === 'income' ? 'text-blue-600' : 'text-red-600'}>{formatToZMW(sumOfArray(receipt.transactions.map(res=>parseFloat(res.amount))))}</span>
                    </div>
                ))
            }
          </div>
        )}

{recId && (
    <Modal title="View Receipt" onClose={() => setRecId(null)}>
        <Receipt receipt={groupedData.find((r) => r.voucher === recId)} council={allData.council[0]?.name} />
    </Modal>

)}
      </div>
    </div>
  );
}
